import {ResetPasswordComponent} from './reset-password.component';
import {RemindPasswordComponent} from './remind-password.component';
import {Route} from '@angular/router';
import {LoginComponent} from './login.component';

export const LoginRoutes: Route[] = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'login/:afterResetMessage',
    component: LoginComponent,
  },
  {
    path: '',
    component: LoginComponent,
  },
  {
    path: 'resetPassword/:login/:expiryTime/:token/:lang',
    component: ResetPasswordComponent,
  },
  {
    path: 'remindPassword',
    component: RemindPasswordComponent,
  },
];
